import { Component } from '@angular/core';

/**
 * Stubbed component to allow Angular Guards to run with AngularJS
 * Refer to: app-routing.module.ts
 */
@Component({
	selector: 'app-ajs',
	template: `<div></div>`,
	// TODO: use a Portal to run AngularJS inside this component?
})
export class AngularJSComponent {}
